import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import data from '../tableocurrence/ocorrencia'
import REEmpreendimentoNovaUnidadeRepositiory from '@/shared/http/repositories/realestate/enterprisenewunit'
import Roles from '@/shared/utils/roles.js'
import PermissionMixin from '@/store/module/permission/mixin'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'

export default {
  name: 'searchocurrence',
  mixins: [ActionsForm, ExpenseMixin, CompanyMixin, AccountMixin, PermissionMixin],
  components: {
    AutocompleteZ
  },
  props: ['flchangeMinizado'],
  data () {
    return {
      title: 'Lista de Chamados',
      formSearch: data,
      Unidade: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      },
      CausaRaiz: [],
      patologias: [],
      dataempreendimento: [],
      statusocorrencia: [],
      TecnicoId: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      },
      types: [
      ],
      roles: Roles
    }
  },
  watch: {
    flchangeMinizado (newvlaue) {
      this.$refs.searchOcurrences.hasMinimizado = newvlaue
    }
  },
  mounted () {
    this.GetProblemaRaiz()
    this.GetPatologia()
    this.GetAllEmpreendimento()
    this.GetStatusOcorrencia()
  },
  methods: {
    GetProblemaRaiz () {
      loading.push()
      OcurrenceRepository.GetProblemaRaiz()
        .then(Response => {
          this.CausaRaiz = Response.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    Search () {
      this.formSearch.TecnicoId = this.TecnicoId.value
      this.formSearch.Unidade = this.Unidade.value
      this.$emit('search', this.formSearch)
      localStoreHelper.controleOcorrencia.ocorrencias(this.formSearch)
    },
    GetPatologia () {
      loading.push()
      OcurrenceRepository.GetPatologia()
        .then(Response => {
          this.patologias = Response.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    GetAllEmpreendimento () {
      // EnterpriseRepository.GetAll()
      REEmpreendimentoNovaUnidadeRepositiory.GetNovaUnidade()
        .then(Response => {
          loading.pop()
          this.dataempreendimento = Response.data
        })
        .catch(Error => {
          loading.pop()
        })
    },
    Clear () {
      this.$refs.UnidadeTypeahead.clear()
      Object.keys(this.formSearch).forEach((Element) => {
        this.formSearch[Element] = null
      })
      this.Nome.value = null
    },
    GetStatusOcorrencia () {
      OcurrenceRepository.GetStatusOcorrencia()
        .then(Response => {
          loading.pop()
          this.statusocorrencia = Response.data
        })
        .catch(Error => {
          loading.pop()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/searchocurrence/searchocurrence.js